import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

const SyndicateListingModal = ({ show, onHide, syndicateListing }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            className="modal-width-548">
            <Modal.Body className="signup-modal-main">
                <div className="d-flex align-items-center justify-content-between">
                    <h2 className="text-center mb-0 m-auto">Confirm Want-Listing syndication to Gitcha</h2>
                </div>
                <div>
                    <p className="text-center mb-32 pt-32">
                        Are you sure you want to syndicate this Want-Listing to the public?
                    </p>
                </div>
                <div className="d-flex gap-3">
                    <Button
                        variant="primary"
                        tabIndex="4"
                        className="flex-fill"
                        onClick={() => syndicateListing()}
                    >
                        Syndicate Want-Listing
                    </Button>
                    <Button
                        variant="tertiary"
                        className="btn btn-tertiary flex-fill"
                        onClick={() => onHide()}
                    >
                        Cancel
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SyndicateListingModal;